import { Array, Literal, Optional, Record, Static, String } from 'runtypes';

const knownJSONTabFactoryTypes = new Set<string>([
	'DesktopModuleIdoActivityApplication',
	'DesktopModuleIdoDocumentApplication',
	'DesktopModuleIdoPrintApplication',
	'DesktopModuleMailAttachmentApplication',
	'IdoIdoGridChangelog',
	'IdoIdoPanelMasterData',
	'IdoIdoRelationsApplication',
	'iframe',
]);

const GenericJSONTabTypeRunType = String.withConstraint((value) => !knownJSONTabFactoryTypes.has(value));

const DesktopModuleCustomFilterConditionIdoLinkingRunType = Record({
	idoId: String,
	instanceId: String,
});

const DesktopModuleCustomFilterConditionRunType = Record({
	key: Literal('idoLinkings'),
	value: Array(DesktopModuleCustomFilterConditionIdoLinkingRunType),
});

export const ChangelogJSONTabFactoryRunType = Record({
	idoId: String,
	idoInstanceId: String,
	title: String,
	type: Literal('IdoIdoGridChangelog'),
});

export type ChangelogJSONTabFactory = Static<typeof ChangelogJSONTabFactoryRunType>;

export const DesktopModuleIdoPrintApplicationJSONTabFactoryRunType = Record({
	desktopModuleCustomFilterCondition: Array(DesktopModuleCustomFilterConditionRunType),
	title: String,
	type: Literal('DesktopModuleIdoPrintApplication'),
});

export type DesktopModuleIdoPrintApplicationJSONTabFactory = Static<
	typeof DesktopModuleIdoPrintApplicationJSONTabFactoryRunType
>;

export const DocumentJSONTabFactoryRunType = Record({
	idoLinkings: Array(DesktopModuleCustomFilterConditionIdoLinkingRunType),
	title: String,
	type: Literal('DesktopModuleIdoDocumentApplication'),
});

export type DocumentJSONTabFactory = Static<typeof DocumentJSONTabFactoryRunType>;

export const HistoryJSONTabFactoryRunType = Record({
	desktopModuleCustomFilterCondition: Array(DesktopModuleCustomFilterConditionRunType),
	title: String,
	type: Literal('DesktopModuleIdoActivityApplication'),
});

export type HistoryJSONTabFactory = Static<typeof HistoryJSONTabFactoryRunType>;

export const GenericJSONTabFactoryRunType = Record({
	itemId: String,
	title: String,
	type: GenericJSONTabTypeRunType,
});

export type GenericJSONTabFactory = Static<typeof GenericJSONTabFactoryRunType>;

export const IFrameTabFactoryRunType = Record({
	requiresCookies: Optional(String),
	requiresSession: Optional(String),
	src: String,
	title: String,
	type: Literal('iframe'),
});

export type IFrameTabFactory = Static<typeof IFrameTabFactoryRunType>;

export const MailAttachmentJSONTabFactoryRunType = Record({
	idoLinkings: Array(DesktopModuleCustomFilterConditionIdoLinkingRunType),
	title: String,
	type: Literal('DesktopModuleMailAttachmentApplication'),
});

export type MailAttachmentJSONTabFactory = Static<typeof MailAttachmentJSONTabFactoryRunType>;

export const MasterDataJSONTabFactoryRunType = Record({
	idoId: String,
	idoInstanceId: String,
	title: String,
	type: Literal('IdoIdoPanelMasterData'),
});

export type MasterDataJSONTabFactory = Static<typeof MasterDataJSONTabFactoryRunType>;

export const RelationsJSONTabFactoryRunType = Record({
	idoLinkings: Array(DesktopModuleCustomFilterConditionIdoLinkingRunType),
	title: String,
	type: Literal('IdoIdoRelationsApplication'),
});

export type RelationsJSONTabFactory = Static<typeof RelationsJSONTabFactoryRunType>;

export type IdoJSONTabFactory =
	| ChangelogJSONTabFactory
	| DesktopModuleIdoPrintApplicationJSONTabFactory
	| DocumentJSONTabFactory
	| GenericJSONTabFactory
	| HistoryJSONTabFactory
	| IFrameTabFactory
	| MailAttachmentJSONTabFactory
	| MasterDataJSONTabFactory
	| RelationsJSONTabFactory;

export type IdoDetailAppTabFactory =
	| DesktopModuleIdoPrintApplicationJSONTabFactory
	| DocumentJSONTabFactory
	| IFrameTabFactory
	| MailAttachmentJSONTabFactory
	| RelationsJSONTabFactory;
